"use client";
import React__default from "react";
import { DefaultGlobalStyles } from "./DefaultGlobalStyles.js";
import { RegisterAudiTheme } from "./audi/index.js";
import { RegisterAutoriaTheme } from "./autoria/index.js";
import { RegisterBilholdLightTheme } from "./bilholdLight/index.js";
import { RegisterBrandlessTheme } from "./brandless/index.js";
import { RegisterCupraTheme } from "./cupra/index.js";
import { RegisterDahlesTheme } from "./dahles/index.js";
import { RegisterGumpenTheme } from "./gumpen/index.js";
import { RegisterMollerBilTheme } from "./mollerBil/index.js";
import { RegisterNyeMollerBilTheme } from "./nyeMollerBil/index.js";
import { RegisterSkodaDarkTheme } from "./skodaDark/index.js";
import { RegisterVolkswagenTheme } from "./vw/index.js";
const RegisterAllThemesAndDefaults = () => {
  return React__default.createElement(
    React__default.Fragment,
    null,
    React__default.createElement(DefaultGlobalStyles, null),
    React__default.createElement(RegisterBilholdLightTheme, null),
    React__default.createElement(RegisterBrandlessTheme, null),
    React__default.createElement(RegisterGumpenTheme, null),
    React__default.createElement(RegisterMollerBilTheme, null),
    React__default.createElement(RegisterNyeMollerBilTheme, null),
    React__default.createElement(RegisterSkodaDarkTheme, null),
    React__default.createElement(RegisterVolkswagenTheme, null),
    React__default.createElement(RegisterDahlesTheme, null),
    React__default.createElement(RegisterAutoriaTheme, null),
    React__default.createElement(RegisterAudiTheme, null),
    React__default.createElement(RegisterCupraTheme, null)
  );
};
export {
  RegisterAllThemesAndDefaults
};
